// Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
// analytics events keep the historical "owner note" name on purpose — do not rename them.

import { publicConfig } from 'config'
import { GOOGLE_REQUIRED_MESSAGE } from 'lib/dealhunt/types'
import { withSlash } from 'lib/dealhunt/url'

const SETTINGS_WORDS = 'account settings'

/**
 * A claim-failure sentence as the reader reads it. The joinable-identity gate's sentence
 * (`google_required`, magic-link D5) links "account settings" to /profile — the Settings that
 * lists the sign-in methods for everyone, hub page or not; any other sentence is plain text.
 */
export function ownerLinkMessage(text: string): React.ReactNode {
  if (text !== GOOGLE_REQUIRED_MESSAGE) {
    return text
  }
  const at = text.indexOf(SETTINGS_WORDS)
  const href = withSlash('/profile', publicConfig('useTrailingSlash'))
  return (
    <>
      {text.slice(0, at)}
      <a href={href}>{SETTINGS_WORDS}</a>
      {text.slice(at + SETTINGS_WORDS.length)}
    </>
  )
}
